import { Component, OnInit, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { filter, map, take, tap } from 'rxjs/operators';

import { ConfigurationStoreHandler } from '../../../../configuration/services/configuration-store-handler.service';
import { DiagnosticOrderActionsService } from '@ispm/test/services/diagnostic-order-actions.service';
import { DiagnosticOrderService } from '@ispm/test/services/diagnostic-order.service';
import { IDefinition } from "../../../../configuration/interfaces/definition.interface";
import { IDiagnosticOrder, IRevision } from '@ispm/test/interfaces/diagnostic-order.interface';
import { RouterManagerService } from "@ispm/core/services/router-manager.service";

@Component({
  selector: 'gen-case-summary',
  templateUrl: './case-summary.component.html',
  styleUrls: ['./case-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CaseSummaryComponent implements OnInit, OnDestroy {
  public formDisabled: boolean = false;
  public formId: string;
  public saveButtonText: string;
  public testFormData: any;

  private $subscription: Subscription = new Subscription();
  private allCaseSummaries = [];
  private currentRevision: IRevision;
  private diagnosticOrderId: string;
  private revisionId: string;

  constructor(
    private configurationAction: ConfigurationStoreHandler,
    private diagnosticOrderActionsService: DiagnosticOrderActionsService,
    private diagnosticOrderService: DiagnosticOrderService,
    private routerManagerService: RouterManagerService
  ) {
  }

  ngOnInit() {
    this.revisionId = this.routerManagerService.parameters?.revisionId;

    this.$subscription.add(
      this.configurationAction.getCurrentConfig()
        .pipe(
          take(1),
          tap((testDefinition: IDefinition) => {
              this.formId = testDefinition.caseSummaryTab.formId;
              this.saveButtonText = testDefinition.caseSummaryTab.saveButtonText;
            }
          )
        ).subscribe()
    );

    this.diagnosticOrderActionsService.getState()
      .pipe(
        filter(state => !!state.order && Object.keys(state.order).length > 0),
        take(1),
        map(state => state.order),
      )
      .subscribe((current: IDiagnosticOrder) => {
        this.diagnosticOrderId = current.id;
        this.currentRevision = current.workflowRequest.revisions.find(rev => rev.id === this.revisionId);

        if (['stopped', 'test completed'].includes(this.currentRevision.status.toLowerCase())) {
          this.formDisabled = true;
          this.saveButtonText = '';
        }

        if (current.caseSummary) {
          this.allCaseSummaries = current.caseSummary;

          let caseSummaryEntry = this.allCaseSummaries.find(summary => summary.revisionId === this.revisionId);

          if (caseSummaryEntry) {
              this.testFormData = caseSummaryEntry['caseSummaryData'];
          }
        }
      });
  }

  ngOnDestroy() {
    this.$subscription.unsubscribe();
  }

  saveData(formData: any) {
    let caseSummary =  { revisionId: this.revisionId,  caseSummaryData: formData }
    let caseSummaryIndex = this.allCaseSummaries.findIndex(summary => summary.revisionId === this.revisionId);

    if ( caseSummaryIndex > -1) {
      this.allCaseSummaries[caseSummaryIndex] = caseSummary;
    }
    else {
      this.allCaseSummaries.push(caseSummary);
    }

    const newDiagnosticOrderFieldData = { caseSummary: this.allCaseSummaries, id: this.diagnosticOrderId };

    this.$subscription.add(
      this.diagnosticOrderService.updateDiagnosticOrderFields(newDiagnosticOrderFieldData)
        .subscribe(
          () => this.diagnosticOrderActionsService.updateDiagnosticOrderFields(newDiagnosticOrderFieldData),
          (err) => console.log(err)
        )
    );
  }
}
